








import { Vue, Component } from 'vue-property-decorator';
import Calendar from '@/modules/calendar/components/Calendar.vue';
import Registrations from '@/modules/admin/components/Registrations.vue';
import WpShortCodesGenerator from '@/modules/wordpress/components/WpShortCodesGenerator.vue';

@Component({
    name: 'AdminMode',
    components: { Calendar, Registrations, WpShortCodesGenerator },
})
export default class AdminMode extends Vue {}
